module.exports = __webpack_public_path__ + "static/media/paf_scholarship_package_2018_-_chicago_chapter_-_criteria___application.b35d6d46.pdf";